var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmittedActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Submitted_Active"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Submitted_Active",
    clipPath: "url(#clip-Submitted_Active)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19562",
    "data-name": "Path 19562",
    d: "M19,0A19,19,0,1,1,0,19,19,19,0,0,1,19,0Z",
    transform: "translate(1.002 3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "notepad_1_",
    "data-name": "notepad (1)",
    transform: "translate(-61.453 -37.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19547",
    "data-name": "Path 19547",
    d: "M87.365,66.942H75.541a2.444,2.444,0,0,1-.424-.2,1.039,1.039,0,0,1-.417-.93q.006-6.472,0-12.948v-.134a.992.992,0,0,1,1.034-1q5.713-.006,11.434,0a1.163,1.163,0,0,1,.472.1.987.987,0,0,1,.565.978c0,1.5,0,3.009,0,4.512,0,2.827,0,5.654,0,8.477a1.511,1.511,0,0,1-.112.573A1,1,0,0,1,87.365,66.942Zm-11.456-14V65.734H87V52.946H84.583v.175c0,.513,0,1.03,0,1.544a.59.59,0,0,1-.417.614,1.1,1.1,0,0,1-.294.033c-1.618,0-3.24,0-4.858,0-.056,0-.108,0-.164-.007a.588.588,0,0,1-.55-.606c0-.528,0-1.06,0-1.588v-.171C77.5,52.942,76.712,52.942,75.909,52.942Zm3.6,0V54.1h3.865V52.938Z",
    fill: "#faac26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19548",
    "data-name": "Path 19548",
    d: "M107.2,84.2h2.392v.171c0,.528,0,1.06,0,1.588a.583.583,0,0,0,.55.606,1.18,1.18,0,0,0,.164.007h4.858a1.114,1.114,0,0,0,.294-.033.593.593,0,0,0,.417-.614c0-.513,0-1.03,0-1.544v-.175h2.414V97H107.2Zm5.527,9.961h3.727c.06,0,.119,0,.179,0a.6.6,0,0,0,.5-.818.629.629,0,0,0-.662-.379h-7.48a1.685,1.685,0,0,0-.193.011.592.592,0,0,0-.491.718.607.607,0,0,0,.651.472ZM112.746,90h0c-.829,0-1.663,0-2.492,0a.581.581,0,0,0-.569.506.59.59,0,0,0,.439.666.958.958,0,0,0,.2.022h4.809c.045,0,.089,0,.134,0a.6.6,0,0,0-.1-1.19C114.356,90,113.553,90,112.746,90Z",
    transform: "translate(-31.291 -31.258)",
    fill: "#fff1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19549",
    "data-name": "Path 19549",
    d: "M204,84.1h3.865v1.164H204Z",
    transform: "translate(-124.491 -31.162)",
    fill: "#fff1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19550",
    "data-name": "Path 19550",
    d: "M140.928,320.9h-3.772a.61.61,0,0,1-.651-.472.592.592,0,0,1,.491-.718,1.637,1.637,0,0,1,.193-.011h7.48a.625.625,0,0,1,.662.379.6.6,0,0,1-.5.818,1.43,1.43,0,0,1-.179,0Z",
    transform: "translate(-59.491 -257.999)",
    fill: "#faac26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19551",
    "data-name": "Path 19551",
    d: "M176.837,240.057h2.418a.585.585,0,0,1,.621.517.6.6,0,0,1-.517.673c-.045,0-.089,0-.134,0h-4.809a.751.751,0,0,1-.2-.022.59.59,0,0,1-.439-.666.578.578,0,0,1,.569-.506c.833,0,1.663,0,2.5,0Z",
    transform: "translate(-95.382 -181.316)",
    fill: "#faac26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_19339",
    "data-name": "Path 19339",
    transform: "translate(26.31 23.086)",
    fill: "#faac26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.34423828125 15.93847846984863 C 4.156758308410645 15.93847846984863 0.7499982714653015 12.53171825408936 0.7499982714653015 8.34423828125 C 0.7499982714653015 4.156758308410645 4.156758308410645 0.7499982714653015 8.34423828125 0.7499982714653015 C 12.53171825408936 0.7499982714653015 15.93847846984863 4.156758308410645 15.93847846984863 8.34423828125 C 15.93847846984863 12.53171825408936 12.53171825408936 15.93847846984863 8.34423828125 15.93847846984863 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8.34423828125 1.499998092651367 C 4.570308685302734 1.499998092651367 1.499998092651367 4.570308685302734 1.499998092651367 8.34423828125 C 1.499998092651367 12.11816787719727 4.570308685302734 15.18847846984863 8.34423828125 15.18847846984863 C 12.11816787719727 15.18847846984863 15.18847846984863 12.11816787719727 15.18847846984863 8.34423828125 C 15.18847846984863 4.570308685302734 12.11816787719727 1.499998092651367 8.34423828125 1.499998092651367 M 8.34423828125 -1.9073486328125e-06 C 12.95263862609863 -1.9073486328125e-06 16.68847846984863 3.735848426818848 16.68847846984863 8.34423828125 C 16.68847846984863 12.95263862609863 12.95263862609863 16.68847846984863 8.34423828125 16.68847846984863 C 3.735848426818848 16.68847846984863 -1.9073486328125e-06 12.95263862609863 -1.9073486328125e-06 8.34423828125 C -1.9073486328125e-06 3.735848426818848 3.735848426818848 -1.9073486328125e-06 8.34423828125 -1.9073486328125e-06 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9722",
    "data-name": "Group 9722",
    transform: "translate(33.514 29.009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3398",
    "data-name": "Group 3398",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1528",
    "data-name": "Path 1528",
    d: "M.5-.21V3.628",
    transform: "translate(-0.499 0.21)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1529",
    "data-name": "Path 1529",
    d: "M.53,0h3.5",
    transform: "translate(-0.494 4.088)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmittedActive);
export default __webpack_public_path__ + "static/media/Submitted_Active.f5068d6a000fef5207b0faabcca125c5.svg";
export { ForwardRef as ReactComponent };